// extracted by mini-css-extract-plugin
export default {"container":"kycAndAcValidate_container__HWjgx","sidenav":"kycAndAcValidate_sidenav__498hK","tabRoot":"kycAndAcValidate_tabRoot__8gj6s"};